import { env } from './env';

export type Skin = (typeof env)['VITE_SKIN'];

export const skin: Skin = env.VITE_SKIN;

export const brandingLogoAlt = skin === 'wh' ? 'William Hill' : 'Caesars Sportsbook';
export const brandAccountName = skin === 'wh' ? 'William Hill' : 'Caesars';

/** Primary CTA hex — used where canvas/SVG cannot read CSS variables. */
export const ctaHex = skin === 'wh' ? '#FEBA31' : '#00E285';
